import React from 'react'
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import CardForm from './components/CardForm'

import queryString from 'query-string'

import { useSelector, useDispatch } from 'react-redux'
import { postLoadReset, postResetSenha } from '../../serviceAPI/resetarsenha';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        height: '95vh'
    },
}));

function ResetarSenha(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const values = queryString.parse(props.location.search)
    const token1 = values.token

    const token2 = useSelector(state => state.resetSenha.token)

    async function resetarSenha(senha) {
        await postResetSenha(token2, senha, dispatch)
    }

    React.useEffect(() => {
        postLoadReset(token1, dispatch)
    }, [token1, dispatch])

    return (
        <Container component="main" >
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.root}
            >
                <CardForm onsubmit={resetarSenha} dispatch={dispatch} />
            </Grid>
        </Container>
    )

}

export default ResetarSenha;